import { FC, RefObject } from "react";
import { useTranslation } from "react-i18next";
import { COMPANY_MISSION_PARAGRAPHS } from "./constants";

interface Props {
  sectionRef?: RefObject<HTMLElement>;
}

export const CompanyMission: FC<Props> = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section className="container" ref={sectionRef}>
      <div className="flex flex-col gap-5 pt-20 pb-5 lg:pb-20 lg:px-20">
        {COMPANY_MISSION_PARAGRAPHS.map((paragaph) => (
          <p
            className="text-purple-base text-justify lg:text-22 gl:text-xl font-light"
            key={paragaph.id}
          >
            {t(paragaph.text.i18nKey)}
          </p>
        ))}
      </div>
    </section>
  );
};
